import { useFlag } from '@unleash/proxy-client-react'
import { shallowEqual, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router'
import Flex from 'styled-flex-component'

import { FeatureToggles, PCRChannels } from '@enums'
import { IApplicationState } from '@store'
import { IPCRChannel, selectPostCampaignReportChannelList } from '@store/postCampaignReport'
import { selectCampaignId } from '@store/router'
import PostCampaignReportChannel from '../Channel'

export interface IInternalProps {
  channels?: ReadonlyArray<IPCRChannel>
}

const PostCampaignReportChannelList = ({ channels: channelsProp }: IInternalProps) => {
  const match = useRouteMatch()
  const campaignId = selectCampaignId(match)!
  const channelsFromStore = useSelector(
    (state: IApplicationState) => selectPostCampaignReportChannelList(state, campaignId),
    shallowEqual,
  )
  const channels = channelsProp ?? channelsFromStore

  const isYouTubeVideosEnabled = useFlag(FeatureToggles.YOUTUBE_STANDARD_ENABLED)

  let pcrChannels = channels

  if (!isYouTubeVideosEnabled) {
    pcrChannels = pcrChannels.filter(({ channel }) => channel !== PCRChannels.YouTubeVideos)
  }

  return (
    <Flex wrap="wrap">
      {pcrChannels.map(({ channel, active, count }) => {
        return (
          <PostCampaignReportChannel
            key={`pcr-channel-${channel}`}
            channel={channel}
            active={active}
            count={count}
          />
        )
      })}
    </Flex>
  )
}

export { PostCampaignReportChannelList }
export default PostCampaignReportChannelList
